import * as React from "react";
import { isLoading, isRejected } from "../../../../helpers";
import { UIMessageStatus } from "../../../../enums";
import { Loader, FreeHtml } from "sb-resp-ui";
import { Remove } from "./../Remove";

const baseClass = "rj-yourbet__message";

export class Message extends React.Component<{
    modifier?: string
    label: string
    type: UIMessageStatus
    handler?: (e: React.MouseEvent<HTMLElement>) => void
}, {}> {
    render() {
        const { modifier, label, type, handler } = this.props;
        const cls = baseClass + (modifier ? ` ${baseClass}--${modifier}` : "");
        return (
            <div className={cls} data-uat={`your-bet-status-${modifier}`}>
                <span className="rj-yourbet__message-text" data-uat="your-bet-message-text">
                    <FreeHtml html={label} />
                </span>

                {isLoading(type) && <Loader />}

                {isRejected(type) && handler &&
                    <Remove modifier="close" data-uat="yourbet-message-close" icon="i-12 i-o-yourbet-close" handler={handler} />
                }
            </div>
        );
    }
}